
import axios,{AxiosInstance,AxiosRequestConfig,AxiosResponse} from 'axios'

const baseUrl = process.env.VUE_APP_BASE_URL ? process.env.VUE_APP_BASE_URL : "/customer_api";

// 创建一个 Request 类
export default class Request {
    public static axiosInstance:AxiosInstance;
    public static init(){
        this.axiosInstance = axios.create({
            baseURL: baseUrl, // 所有的请求地址前缀部分
            timeout: 60000, // 请求超时时间毫秒
        })
        this.initInterceptors()
        return axios
    }
    public static initInterceptors(){
        this.axiosInstance.defaults.headers.post['Content-Type'] = "application/json;charset=utf-8"
        this.axiosInstance.defaults.headers.post.withCredentials = true
        this.axiosInstance.interceptors.request.use(
            (config:AxiosRequestConfig) => {
                return config
            },
            (error:any) => {
                console.log(error)
            }
        )
        this.axiosInstance.interceptors.response.use(
            (response:AxiosResponse) => {
                const code = response.data.code
                if (!code) return Promise.reject(response)
                return response.data
            },
            (error:any) => {
                console.log(error);
            }
        )
    }
    // private static errorHandle(res:any){
    //     throw new Error(res);
    // }
}

